export default {
	login: 'Login'
}